export default {
    props: {
        scrollable: {
            type: String,
            default: function () {
                return "";
            }
        },
        title: {
            type: String,
            default: function () {
                return "";
            }
        },
        headers: {
            type: Array,
            default: function () {
                return [];
            }
        },
        columns: {
            type: Array,
            default: function () {
                return [];
            }
        },
        icon: {
            type: String,
            default: function () {
                return "";
            }
        },
        actions: {
            type: Object,
            default: function () {
                return {};
            }
        },
        basicData: {
            type: Object,
            default: function () {
                return {};
            }
        },
        actionButtons: {
            type: Array,
            default: function () {
                return [];
            }
        },
        addButtonText: {
            type: String,
            default: function () {
                return "";
            }
        },
        showClearButton: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        clearButtonText: {
            type: String,
            default: function () {
                return 'Clear All Links';
            }
        },
        clearButtonIcon: {
            type: String,
            default: function () {
                return 'mdi-recycle-variant';
            }
        },
        stateendpoint: {
            type: String,
            default: function () {
                return "";
            }
        },
        popupComponent: {
            type: Object,
            default: function () {
                return null;
            }
        },
        showDefaultActionButtons: {
            type: Boolean,
            default: function () {
                return true
            }
        },
        disableDefaultFooter: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        disablePagination: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        showAddButton: {
            type: Boolean,
            default: function () {
                return true;
            }
        },
        showPageTitle: {
            type: Boolean,
            default: function () {
                return true;
            }
        },
        descending: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        sort: {
            type: String,
            default: function () {
                return 'name';
            }
        },
        summaryOfStockCalc: {
            type: Object,
            default: function () {
                return null;
            }
        },
        showInvoiceButton: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        showMailBoxNewsLetter: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        showSelect: {
            type:Boolean,
            default: function () {
                return false;
            }
        },
        param1: {
            type: [Number, String],
            default: function () {
                return 0;
            }
        },
        isShowClient: {
            type:Boolean,
            default: function () {
                return false;
            }
        },
        showSendMailTemplate: {
            type:Boolean,
            default: function () {
                return true;
            }
        }
    },
}